export default {
  delHtmlTag (str) {
    return str.replace(new RegExp("\'", "gm"), '').replace(/<[^>]+>/g, '').replace(/&nbsp;/ig, "").replace(/\s/g,"")
  }
}


// WEBPACK FOOTER //
// ./src/utils/delHtmlTag.js